"use client";

import { Button, Heading, Link, Text } from "@pamperedchef/design-system";

import * as styles from "./ListingMessage.module.scss";

export interface ListingMessageAction {
	label: string;
	href?: string;
	onPress?: () => void;
}

export interface ListingMessageProps {
	heading: string;
	body?: string;
	actions: ListingMessageAction[];
}

export function ListingMessage({
	heading,
	body,
	actions
}: ListingMessageProps): JSX.Element {
	return (
		<div className={styles["message"]} data-component="ListingMessage">
			<Heading tag="h2" className={styles["message__heading"]}>
				{heading}
			</Heading>
			{body ? (
				<Text tag="p" className={styles["message__body"]}>
					{body}
				</Text>
			) : null}
			<div className={styles["message__actions"]}>
				{actions.map(({ label, href, onPress }) =>
					href ? (
						<Link key={label} href={href} size="md">
							{label}
						</Link>
					) : (
						<Button
							key={label}
							kind="secondary"
							size="lg"
							onPress={onPress}
						>
							{label}
						</Button>
					)
				)}
			</div>
		</div>
	);
}
